import Animation from './core';

export default class Intro extends Animation {
  constructor(ele, options) {
    super(ele, options);

    this.moveForce = 20;
    this.rotateForce = 20;

    this.$window = $(window);
    // $(document).mousemove(this.onDocumentMouseMove.bind(this));

    /*if(window.requestAnimationFrame) {
            window.requestAnimationFrame(this.onAnimationFrame.bind(this));
        }*/

    this.pageX = 0;
    this.pageY = 0;

    TweenMax.set(['.back_circle', '.intro .main_deco_3', '.intro .main_deco_2', '.intro .main_deco_1'], {
      transformPerspective: 400,
    });
  }

  onDocumentMouseMove(e) {
    this.pageX = e.pageX;
    this.pageY = e.pageY;

    this.onAnimationFrame();
  }

  onAnimationFrame(time) {
    let winX = this.$window.width();
    let winY = this.$window.height();
    let cx = winX / 2;
    let cy = winY / 2;

    let moveX = ((this.pageX - cx) / cx) * -this.moveForce;
    let moveY = ((this.pageY - cy) / cx) * -this.moveForce;

    let rotateY = (this.pageX / winX) * this.rotateForce * 2 - this.rotateForce;
    let rotateX = -((this.pageY / winY) * this.rotateForce * 2 - this.rotateForce);

    TweenMax.to('.main_deco_3', 0.6, { x: moveX, y: moveY, z: moveX });
    TweenMax.to('.back_circle', 0.6, { z: moveX });

    TweenMax.to('.main_deco_2', 0.6, { x: moveX, y: moveY });
    TweenMax.to('.main_deco_1', 0.8, { x: moveX, y: moveY });

    // window.requestAnimationFrame(this.onAnimationFrame.bind(this));
  }

  addTimeline() {
    let back = this.getElement('.back_circle');
    let deco3 = this.getElement('.main_deco_3');
    let deco2 = this.getElement('.main_deco_2');
    let deco1 = this.getElement('.main_deco_1');
    let device = this.getElement('.m_device');
    let shadow = this.getElement('.m_device .shadow');
    let images = this.getElement('.m_device .images > span', false);

    let tl = this._tl;
    tl.set(back, { opacity: 0.6 });
    tl.set([back, deco3], { scale: 0 });
    tl.set(device, { y: 80, transformPerspective: 200 });
    tl.set(deco2, { y: 80 });
    tl.set(deco1, { scale: 0 });
    // tl.set(images.eq(0), {opacity: 1});
    // tl.set(images.eq(1), {scale: 0.5});
    // tl.set(images.eq(2), {scale: 0.5});

    tl.to(back, 0.6, { scale: 1, opacity: 0.05, ease: Power2.easeOut }, 0);
    tl.to(device, 0.6, { opacity: 1, y: 0, ease: Quad.easeOut }, 0.2);
    tl.to(shadow, 0.8, { opacity: 1, y: 0, ease: Quad.easeOut }, 0.8);
    tl.to(deco3, 0.6, { rotation: 0, scale: 1, opacity: 1, ease: Quad.easeOut }, 0.4);
    tl.to(deco1, 0.4, { scale: 1, opacity: 1, ease: Quad.easeOut }, 0.8);
    tl.call(() => {
      // deco1.addClass('buzz');
      // deco1.addClass('hang');
      // deco3.find('span').addClass('hang');
    });
    tl.to(deco2, 0.6, { y: 0, opacity: 1, ease: Quad.easeOut }, 1.5);
    tl.call(() => {
      // deco2.addClass('hang');
    });
    /*tl.to(images.eq(0), 0.8, {opacity: 0, scale:0, ease: Power2.easeOut}, 2);
        tl.to(images.eq(1), 0.8, {opacity: 1, scale:1, ease: Power2.easeOut}, 2);
        tl.to(images.eq(1), 0.8, {opacity: 0, scale:0, ease: Power2.easeOut}, 5);
        tl.to(images.eq(2), 0.8, {opacity: 1, scale:1, ease: Power2.easeOut}, 5);*/
  }
}
